export class ActionFile{
    public ActionID:number = -1;
    public FileData:File;
       constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}